//load a configId if it is found in the url parameters
document.addEventListener('DOMContentLoaded', function() {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const configid = urlParams.get('configid');

  if (configid) {
    const hmc360Configurator = document.getElementById('hmc360-configurator');
    const hmc360Viewer = document.getElementById('hmc360-viewer');
    
    const newConfigurator = document.createElement('div');
    newConfigurator.id = 'configured360Configurator';
    newConfigurator.className = 'intiaroMenuController';
    newConfigurator.setAttribute('data-customer-id', 'HowardMillerHekman');
    newConfigurator.setAttribute('data-product-id', configid); 
    newConfigurator.setAttribute('data-mode', 'user_configuration');
    
    
    hmc360Configurator.parentNode.insertBefore(newConfigurator, hmc360Configurator);

    IntiaroConfigurator.create('configured360Configurator');

    hmc360Viewer.setAttribute('data-target', 'configured360Configurator');
    hmc360Configurator.remove();
  }
});

document.addEventListener('DOMContentLoaded', function() {
  let userIsADeveloper = false;
  let userHasInteractedWithConfigurator = false;

  if(window.customer?.tags && window.customer.tags.includes('hmc-developer')){
    userIsADeveloper = true;
  }
  
  $(document).on('click', '.choiceIconContainer', function(event) {
    userHasInteractedWithConfigurator = true;
    getIntiaroPlayer("hmc360-viewer").saveConfiguration(configurationID => {
      window.config_id = configurationID;
    });
  });

  if (userIsADeveloper) {
    //testWithT();
  }
  
  window.addEventListener('pagehide', () => {
    if (!userIsADeveloper && userHasInteractedWithConfigurator) {
      handleImageUpload();
    }
  });
});

async function handleImageUpload() {
  const frame_url = getIntiaroPlayer("hmc360-viewer").getFrameUrl(0);
  if (!frame_url) return;
  
  const payload = JSON.stringify({
    frame_url,
    product_sku: window.ShopifyAnalytics.meta.product.variants[0].sku,
    product_id:  window.ShopifyAnalytics.meta.product.id,
    config_id: window.config_id,
    store_name: "howard_miller"
  });
    
  fetch('https://isotope.howardmiller.com/store_intiaro_image', {
    method: 'POST',
    body: payload,
    keepalive: true,
    headers: { 'Content-Type': 'application/json' }
  });
}

function testWithT(){
   document.addEventListener('keydown', function(e) {
    if (e.key === 't' || e.key === 'T') {
      handleImageUpload();
    }
  });
}

$(document).ready(function() {
  createCarousel();

  function createCarousel() {
    //use the first two characters of the .sku__value text as SKU
    let pdp_sku = $('.sku__value').text().substring(0,2);
    
    fetch('https://isotope.howardmiller.com/get_intiaro_images', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ sku: pdp_sku })
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      if (data.success && Array.isArray(data.plytixImages)) {
        const images = data.plytixImages.map(image => {
          const imageUrl = image.url;
          const filename = imageUrl.substring(imageUrl.lastIndexOf('/') + 1);
          const configid = filename.substring(0, filename.lastIndexOf('.')).split('_').pop();
          return { url: imageUrl, configid: configid };
        });

        if(images.length < 6){
          $('#hmc360-carousel-wrapper').hide();
          return;
        }
        
        const carouselContainer = $('#hmc360-carousel');
        const carouselInner = $('<div class="hmc360-carousel-inner"></div>');
        const itemWidth = 360; 
        const gap = 16; 
        const numImages = images.length;
        const totalItemWidth = (itemWidth * numImages) + (gap * (numImages - 1));
        
        carouselInner.css('width', `${2 * totalItemWidth}px`);
        carouselContainer.css('width', `${totalItemWidth}px`);

        // Add original set
        createCarouselItems(carouselInner, images);
        // Add duplicate set for seamless scroll
        createCarouselItems(carouselInner, images);

        carouselContainer.empty();
        carouselContainer.append(carouselInner);
      } else {
        let message = 'Failed to load images.';
        if (data && Array.isArray(data.plytixImages) && data.plytixImages.length < 6 && data.plytixImages.length > 0) {
            message = 'Not enough images to display (minimum 6 required).';
        } else if (data && data.message) {
            message += ` Server: ${data.message}`;
        }
        console.log(message);
        $('#hmc360-carousel-wrapper').hide();
      }
    })
    .catch(error => {
      $('#hmc360-carousel').text('Error loading images.');
      console.error(error);
    });
  }

  function createCarouselItems(carouselInner, images){
    for (let i = 0; i < images.length; i++) {
      const image = images[i];
      let url = window.location.href.split('?')[0];
      url += "?configid=" + image.configid;

      const carouselItem = $('<div class="hmc360-carousel-item"></div>');
      const link = $('<a></a>').attr('href', url);
      const img = $('<img>')
        .attr('src', image.url)
        .attr('alt', 'HMC360 Image ' + (i + 1));

      link.append(img);
      carouselItem.append(link);
      carouselInner.append(carouselItem);
    }
  }
});